/**
 * TTS 资源库的展示文案、标签颜色（antd 预设色名）和格式化工具，与旧版 TTSResourceView.vue 一致
 */
import { env } from '@/utils/env'

export const PROVIDER_OPTIONS = [
  { value: 'elevenlabs', label: 'ElevenLabs' },
  { value: 'google', label: 'Google TTS' }
]

const PROVIDER_COLORS: Record<string, string> = {
  elevenlabs: 'blue',
  google: 'green'
}

const STATUS_CONFIG: Record<string, { label: string; color: string }> = {
  pending: { label: '待生成', color: 'default' },
  generating: { label: '生成中', color: 'processing' },
  completed: { label: '已完成', color: 'success' },
  failed: { label: '失败', color: 'error' }
}

export const STATUS_OPTIONS = Object.entries(STATUS_CONFIG).map(([value, { label }]) => ({ value, label }))

export function providerColor(provider: string) {
  return PROVIDER_COLORS[provider] ?? 'default'
}

export function statusColor(status: string) {
  return STATUS_CONFIG[status]?.color ?? 'default'
}

export function statusText(status: string) {
  return STATUS_CONFIG[status]?.label ?? status
}

// 后端返回的相对路径（/uploads/...）拼上 API 地址
export function audioUrl(url: string) {
  return url.startsWith('/') ? `${env.apiBaseUrl}${url}` : url
}

export function truncateText(text: string, maxLength: number) {
  return text.length <= maxLength ? text : `${text.substring(0, maxLength)}...`
}

export function formatFileSize(bytes: number) {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`
}

export function formatCost(cost: number | undefined, digits: number) {
  return cost ? `$${Number(cost).toFixed(digits)}` : '-'
}
